import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Input } from '@angular/core';
import { ModelPoolService } from '../../../services/model-pool.service';

/**
 * Models lens — Setup tab section between Credentials and Agents: the
 * READ-ONLY derived noun from the 2026-08-13 design session. Credentials
 * unlock models; this lens shows the resulting pool, each row a
 * (model, credential) tuple with the credential as a subtle property.
 */
@Component({
  selector: 'app-model-pool-lens',
  templateUrl: './model-pool-lens.component.html',
  styleUrls: ['./model-pool-lens.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModelPoolLensComponent implements OnInit {
  groups: ModelPoolService.PoolGroup[] = [];
  loading = true;
  expanded = false;

  @Input() teamName: string | null = null;   // the panel's venue (Agents app)

  constructor(private pool: ModelPoolService, private cdr: ChangeDetectorRef) {}

  async ngOnInit(): Promise<void> {
    try {
      this.groups = await this.pool.groups(true, this.teamName || undefined);
    } catch { this.groups = []; }
    this.loading = false;
    this.cdr.markForCheck();
  }

  get total(): number {
    return this.groups.reduce((n, g) => n + g.models.length, 0);
  }

  modeLabel(mode: string | null): string {
    return mode === 'subscription' ? 'subscription'
      : mode === 'api_key' ? 'per-token' : (mode || '');
  }
}
